
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-76/traits/[traitName]",
      function () {
        return require("private-next-pages/info/set-76/traits/[traitName].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-76/traits/[traitName]"])
      });
    }
  